import CartContainer from "../../../../Components/Applications/ECommerce/Cart/CartContainer";

const Cart = () => {
  return <CartContainer />;
};

export default Cart;
